<template>
  <section>
    <div class="pay-course"
      :data-price="courseData.price">
      <div class="pay-course-info">
        <div><img :src="courseData.img"></div>
        <div>{{ courseData.name }}</div>
      </div>
    </div>
    <div class="pay-coupon"
      v-if="couponList.length">
      <div class="pay-coupon-button"
        :class="{ 'spread': isCouponVisible, 'selected': selectedCoupon.id }"
        @click="handleToggleCoupon"
        :data-coupon="discountPrice | fixedNumber(2)">
      </div>
      <ul class="pay-coupon-list"
        :class="{ 'spread': isCouponVisible }">
        <li v-for="(item, index) in couponList"
          :key="index + item.id"
          :class="{ 'active': item.id === selectedCoupon.id }"
          @click="handleSelectCoupon(item)">{{ item.title }}</li>
      </ul>
    </div>
    <div class="pay-bonus"
         v-if="bonus">
      <div class="pay-bonus-button"
           :class="{ 'spread': isBonusVisible, 'selected': selectedBonus }"
           @click="handleToggleBonus"
           :data-bonus="discountBonus | fixedNumber(2)">
      </div>
      <ul class="pay-bonus-list"
          :class="{ 'spread': isBonusVisible }">
        <!--<li v-for="(item, index) in couponList"-->
            <!--:key="index + item.id"-->
            <!--:class="{ 'active': item.id === selectedCoupon.id }"-->
            <!--@click="handleSelectCoupon(item)">{{ item.title }}</li>-->
        <li :class="{ 'active': selectedBonus }" @click="handleSelectBonus()">使用{{discountBonus}}元奖励金(共{{bonus}}元)</li>
      </ul>
    </div>
    <div class="pay-method" v-if="!isAli">
      <ul class="pay-method-list"
        @click="handleSelectPayWay($event)">
        <li data-type="11"
          v-if="isLoanApp && canLoan"
          :class="{ 'active': payWay === '11' }">金山贷分期</li>
        <li data-type="10"
          :class="{ 'active': payWay === '10' }">微信</li>
        <li data-type="9"
          v-if="isZFBVisible"
          :class="{ 'active': payWay === '9' }">支付宝</li>
      </ul>
    </div>
  </section>
</template>

<script>
import os from '@edu-fe/os'
import fixedNumber from '../filters/fixed-number.js'

export default {
  name: 'PayMoney',
  props: {
    courseData: {
      type: Object,
      default: () => {}
    },
    couponList: {
      type: Array,
      default: () => []
    },
    discountPrice: {
      type: Number,
      default: 0
    },
    isLoanApp: {
      type: Boolean,
      default: false
    },
    canLoan: {
      type: Boolean,
      default: false
    },
    bonus: {
      type: Number,
      default: 0
    },
    discountBonus: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      isBonusVisible: true,
      selectedCoupon: {}, // 选择的优惠券
      isCouponVisible: true, // 展示优惠券列表
      selectedBonus: false,
      payWay: '10' // 支付方式 9: 支付宝 10: 微信 11: 金山贷分期
    }
  },
  computed: {
    isZFBVisible () {
      return os.type === 'browser' && os.name !== 'loan'
    },
    isAli () {
      return os.type === 'ali'
    }
  },
  filters: {
    fixedNumber
  },
  created () {
    setTimeout(() => {
      if (this.canLoan) {
        this.payWay = '11'
        this.$emit('selectPayWay', this.payWay)
      }
    }, 300)
  },
  watch: {
    couponList: {
      handler (e) {
        this.handleSelectCoupon(e[0])
      },
      deep: true
    },
    bonus (val) {
      this.handleSelectBonus()
    }
  },
  methods: {
    handleToggleCoupon () {
      this.isCouponVisible = !this.isCouponVisible
    },
    handleToggleBonus () {
      this.isBonusVisible = !this.isBonusVisible
    },
    handleSelectCoupon (item) {
      if (!item) {
        return
      }
      if (item.id === this.selectedCoupon.id) { // 取消当前的优惠券
        this.selectedCoupon = {}
      } else {
        this.selectedCoupon = item
      }
      this.$emit('selectCoupon', this.selectedCoupon)
    },
    handleSelectPayWay (e) {
      this.payWay = e.target.getAttribute('data-type')
      this.$emit('selectPayWay', this.payWay)
    },
    handleSelectBonus () {
      this.selectedBonus = !this.selectedBonus
      this.$emit('selectBonus', this.selectedBonus)
    }
  }
}
</script>
